export default __webpack_public_path__ + "static/media/Funding-growth-financing.0ef9e2e6.png";